import { Navigate } from 'react-router-dom';

import useUserState from '@/hook/useUserState';
import { 월별_결제_내역_다운로드_라우터 } from '@/router/cafe24-master-account';
import { roleCafe24Master, roleOwner } from '@/router/consts';
import { sellerMap } from '@/router/managementMaps';
import { 매니저_라우터 } from '@/router/manager';

/**
 * 루트 경로 리다이렉션 핸들러 컴포넌트
 *
 * 사용자가 루트 경로(/)에 접근했을 때 권한에 따라 적절한 페이지로 리다이렉션합니다.
 * - 미인증 사용자: 로그인 페이지로 이동
 * - 카페24 마스터: 카페24 결제 내역 페이지로 이동
 * - 일반 사업자: 대시보드로 이동
 * - 관리자: 샵 목록 페이지로 이동
 *
 * @description 사용자 권한 기반 초기 라우팅 처리
 */
export default function RedirectHandler() {
  const user = useUserState();

  switch (user?.roles[0]) {
    case undefined:
      return <Navigate to={'/login'} replace={true} />;
    case roleCafe24Master:
      return <Navigate to={월별_결제_내역_다운로드_라우터['cafe24'].path} replace={true} />;
    case roleOwner:
      return <Navigate to={sellerMap['dashboard'].path} replace={true} />;
    default:
      return <Navigate to={매니저_라우터['shop-list'].path} replace={true} />;
  }
}
